import { render, staticRenderFns } from "./tenantConfigMobile.vue?vue&type=template&id=5a7ea7ee&scoped=true"
import script from "./tenantConfigMobile.vue?vue&type=script&lang=js"
export * from "./tenantConfigMobile.vue?vue&type=script&lang=js"
import style0 from "./tenantConfigMobile.vue?vue&type=style&index=0&id=5a7ea7ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ea7ee",
  null
  
)

export default component.exports